import { IconName } from '@shared/components/core/images/IconMap';
import { OrganizationMemberRoleKeys } from '@shared/models/organizations/OrganizationMemberRole';

export const roleIcons: Record<OrganizationMemberRoleKeys, IconName> = {
    isAdmin: 'orgAdmin',
    canViewMembers: 'orgMembers',
    canInviteMembers: 'orgInvite',
    canChangeMemberPermissions: 'orgPermissions',
    canRemoveMembers: 'orgDeleteUser',
    canCreateAuthClients: 'orgAuthClient',
    canViewAuthClients: 'orgAuthClient',
    canManageBilling: 'orgTransaction',
    canManageChildOrganizations: 'orgAdmin',
    canViewAnalytics: 'futures',
    canAccessOrganizationProfiles: 'purchaseOrder',
    canEditOrganizationProfiles: 'purchaseOrder',
    canManageGlobalAutomationRules: 'automation',
};
